export default {
  versions: [],
  loadingVersions: false,
  loadingChangesets: false,
  modalShowing: false,
  modalContent: undefined,
  changesets: [],
  refreshVersions: false,
  isCreatingVersion: false
}
